import { useToast } from '../../../context/ToastContext.jsx'

/** Courier name, AWB with a copy button, destination, and the courier's own tracking page. */
export default function CourierDetails({ shipment }) {
  const { showToast } = useToast()
  const name = shipment.courier?.name ?? shipment.courier_name
  const awb = shipment.courier?.awb ?? shipment.awb_code
  const trackUrl = shipment.courier?.track_url ?? shipment.track_url

  const copyAwb = async () => {
    try {
      await navigator.clipboard.writeText(awb)
      showToast('Tracking number copied')
    } catch {
      showToast(`Tracking number: ${awb}`)
    }
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <dl className="grid grid-cols-1 sm:grid-cols-3 gap-x-8 gap-y-4 text-sm tracking-wider grow">
        <Fact label="Courier" value={name || '—'} />
        <Fact
          label="Tracking No. (AWB)"
          value={
            awb ? (
              <button
                type="button"
                onClick={copyAwb}
                aria-label={`Copy tracking number ${awb}`}
                className="inline-flex items-center gap-2 font-mono normal-case hover:text-secondary focus-visible:outline-2 focus-visible:outline-secondary rounded transition-colors"
              >
                {awb}
                <i className="fa-regular fa-copy text-xs text-primary/40" aria-hidden="true"></i>
              </button>
            ) : (
              '—'
            )
          }
        />
        {shipment.destination_city && <Fact label="Delivering to" value={shipment.destination_city} />}
      </dl>
      {trackUrl && (
        <a
          href={trackUrl}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-2 h-10 px-5 rounded-xl border border-primary/20 text-primary text-xs font-bold tracking-[0.15em] hover:border-secondary hover:text-secondary transition-all shrink-0"
        >
          Courier site
          <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true"></i>
          <span className="sr-only">(opens in a new tab)</span>
        </a>
      )}
    </div>
  )
}

function Fact({ label, value }) {
  return (
    <div className="min-w-0">
      <dt className="text-xs text-primary/40">{label}</dt>
      <dd className="mt-1 text-primary font-medium wrap-break-word normal-case">{value}</dd>
    </div>
  )
}
